import React from 'react';
import { Proposal } from './PostsListWrapper';
import BuyerProposalBasicCard from './BuyerProposalBasicCard';
import { useTranslation } from 'react-i18next';

export default function PostList({
  proposals,
}: {
  proposals: Proposal[];
}) {
  const { t, i18n } = useTranslation();
  const locale = i18n.language || 'en';

  const translator = (
    key: string,
    values?: Record<string, string | number | Date | null | undefined>
  ) => {
    return t(`components.${key}`, values as Record<string, unknown>);
  };

  const currencyDisplay = t('components.SAR');

  return (
    <div className="flex flex-col space-y-4" data-testid="post-details-proposals-list">
      {proposals?.map((proposal) => (
        <div
          key={proposal?.id}
          data-testid={`post-details-proposal-row-${proposal.id}`}
        >
          <BuyerProposalBasicCard
            proposal={proposal}
            tags={proposal?.statuses}
            locale={locale}
            t={translator}
            currencyDisplay={currencyDisplay}
            withPadding
          />
        </div>
      ))}
    </div>
  );
}
